$(document).ready(() => {
  $("body").on("click", ".banner-info-btn", function () {
    const $target = $(this).data("bs-target");
    const $infoBox = $("#bannerInfoModal");

    if (bannerData[$target]) {
      const $img = bannerData[$target]["img"];
      const $infoText = bannerData[$target]["info"];

      $infoBox.find(".img-before").css("background-image", "url('" + $img + "')");
      $infoBox.find(".typo blockquote").html($infoText);

      $infoBox.modal("show");
    }
  });

  $("body").on("click", ".infotext-btn", function () {
    const $target = $(this).parents(".slide-item").data("info-target");
    const $infoBox = $("#infoTextModal");

    if (bannerData[$target]) {
      const $img = bannerData[$target]["img"];
      const $infoText = bannerData[$target];

      $infoBox.find(".inner-content").html($infoText);

      $infoBox.modal("show");
    }
  });

  $("body").on("click", ".infotext2-btn", function () {
    const $target = $(this).parents(".slide-item").data("info-target2");
    const $infoBox = $("#infoTextModal");

    if (bannerData[$target]) {
      const $img = bannerData[$target]["img"];
      const $infoText = bannerData[$target];

      $infoBox.find(".inner-content").html($infoText);

      $infoBox.modal("show");
    }
  });

  /* RESET HEIGHT OF BANNER SLIDER ON SUCCESS OF CHECK ADDRESS AJAX  */
  $("body").on("click", "#addressModal .close, #syncModal .close, a.clear-address, a.revert-address", function () {
    setTimeout(function () {
      $(".home .desktop-banner, .home .mobile-banner").slick("animateHeight");
    }, 100);
  });

  // INTERNET PLANS TABS
  // SET TAB ACTIVE
  $("#ip-tab-btns").on("click", "li", function () {
    $("#ip-tab-btns li").each(function () {
      $(this).removeClass("active");
    });
    $(".ip-slider").each(function () {
      $(this).addClass("hide-slider");
    });
    $(this).addClass("active");
    $("#" + $(this).data("value")).removeClass("hide-slider");

    //Temporary fix due to responsive issues on slider
    $("#" + $(this).data("value"))
      .fadeTo(1, 0.01)
      .fadeTo(300, 0.01)
      .fadeTo(300, 1);
    // $('.mh-title').matchHeight({
    //     byRow: true
    // });
    // $('.mh-content').matchHeight({
    //     byRow: true
    // });
  });

  $("#ip-tab-btns-m").on("click", "li", function () {
    $("#ip-tab-btns-m li").each(function () {
      $(this).removeClass("active");
    });
    $(".ip-slider").each(function () {
      $(this).addClass("hide-slider");
    });
    $(this).addClass("active");
    $("#" + $(this).data("value")).removeClass("hide-slider");

    // $('.mh-title-m').matchHeight({
    //     byRow: true
    // });
    // $('.mh-content-m').matchHeight({
    //     byRow: true
    // });
  });

  // if (ipslides == true) {

  let desktopCarouselsInitialised = false;
  let mobileCarouselsInitialised = false;

  // Initialise appropriate carousels
  function initialiseAppropriateCarousels(mediaQueryDesktop) {
    if (mediaQueryDesktop.matches) {
      initialiseDesktopCarousels();
    } else {
      initialiseMobileCarousels();
    }
  }

  // Desktop
  function initialiseDesktopCarousels() {
    if (desktopCarouselsInitialised) {
      return;
    }

    console.log("Initialising carousels for desktop");

    desktopCarouselsInitialised = true;

    $("#ip-owl").owlCarousel({
      items: 2,
      margin: 19,

      loop: false,

      nav: true,
      autoplay: false,
      autoplayTimeout: 4000,
      slideTransition: "slide",
      responsive: {
        // 768: {
        //   items: 2,
        // },
        1024: {
          items: 3,
        },
      },
    });

    $("#mp-owl").owlCarousel({
      items: 2,
      margin: 19,

      loop: false,
      margin: 19,
      nav: true,
      autoplay: false,
      autoplayTimeout: 4000,
      responsive: {
        // 768: {
        //   items: 2,
        // },
        1024: {
          items: 3,
        },
      },
    });

    $("#bp-owl").owlCarousel({
      items: 2,
      margin: 19,

      loop: false,
      margin: 19,
      nav: true,
      // center: true,
      autoplay: false,
      autoplayTimeout: 4000,
      responsive: {
        // 768: {
        //   items: 2,
        // },
        1024: {
          items: 3,
        },
      },
    });
  }

  // Mobile
  function initialiseMobileCarousels() {
    if (mobileCarouselsInitialised) {
      return;
    }

    console.log("Initialising carousels for mobile");

    mobileCarouselsInitialised = true;
    $("#ip-owl-m").owlCarousel({
      items: 1,
      loop: true,
      margin: 19,
      nav: true,
      autoplay: true,
      autoplayTimeout: 4000,
      animateOut: "fadeOut",
    });

    $("#mp-owl-m").owlCarousel({
      items: 1,
      loop: true,
      margin: 19,
      nav: true,
      autoplay: true,
      autoplayTimeout: 4000,
      animateOut: "fadeOut",
    });

    $("#bp-owl-m").owlCarousel({
      items: 1,
      loop: false,
      margin: 19,
      nav: true,
      // center: true,
      autoplay: true,
      autoplayTimeout: 4000,
      animateOut: "fadeOut",
    });

    $(".latest-from-your-mates .owl-carousel").owlCarousel({
      items: 1,
      loop: true,
      margin: 19,
      dotsContainer: ".pagination-from-your-mates",
      nav: false,
    });
  }

  // Tablets +
  const mediaQueryDesktop = window.matchMedia("(min-width: 768px)");

  initialiseAppropriateCarousels(mediaQueryDesktop);
  mediaQueryDesktop.addEventListener("change", initialiseAppropriateCarousels);
});
